import React from 'react'
import { X } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { useTheme } from '@/context/ThemeContext'

interface AskAnythingHeaderProps {
  onClose: () => void
  isComposeMode?: boolean
}

const AskAnythingHeader: React.FC<AskAnythingHeaderProps> = ({ onClose, isComposeMode }) => {
  const { isDarkMode } = useTheme()

  return (
    <div
      className={`h-topbar ${isDarkMode ? 'text-white' : 'text-gray-800'} z-50 flex items-center px-6 justify-between`}
    >
      {/* Time window selector moved to the input area */}

      <div className="flex items-center gap-4 ml-auto">
        <Button
          onClick={onClose}
          variant="outline"
          size="icon"
          className={`h-9 w-9 rounded-full border-2 hover:bg-gray-100 transition-colors ${
            isDarkMode
              ? 'border-gray-500 text-white hover:bg-gray-800'
              : 'border-gray-400 text-gray-700 hover:text-red-600 hover:border-red-400'
          }`}
        >
          <X className="h-5 w-5" />
        </Button>
      </div>
    </div>
  )
}

export default AskAnythingHeader